import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { EVENT_TYPE } from "../Model/Model";
import { MEDIA_OPTIONS } from "../../../Traffic/Manage/Model/Model";
import { CommentsTitle, EmailSubsectionChip, PhoneSubsectionChip } from "../../../../../components/buttons/IconButtons";
import { STATUS_MODEL } from "../../../../../enums/statusEnum";
import BorderTopTable from "../../subComponents/BorderTopTable";



/**
 * @Author: Susana García Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.m
 */

const NotificationChannelsTable = ({ item, handleChange, disabled }) => {
    const { t } = useTranslation();
    // Extract media option settings from item or fallback to empty array
    const eventSettingMediaOptionDto =
        item?.eventSettingMediaOptionDto || [];
    // Check if a specific event type and media option is active
    const isChecked = (eventTypeId, mediaOptionId) => {
        return eventSettingMediaOptionDto.some(
            (opt) =>
                opt.eventType === eventTypeId &&
                opt.mediaOption === mediaOptionId &&
                opt.status?.id === STATUS_MODEL.ACTIVE_COMPANY
        );
    };
    // Define table columns with labels and icons
    const columns = useMemo(() => [
        {
            key: "email",
            label: "email",
            icon: <EmailSubsectionChip width={20} height={20} />,
        },
        {
            key: "mobile",
            label: "mobile",
            icon: <PhoneSubsectionChip width={20} height={20} />,
        },
        {
            key: "app",
            label: "app",
            icon: <CommentsTitle width={20} height={20} />,
        },
    ], []);

    // Build table rows based on event types and their enabled media options
    const rows = useMemo(() => {
        return Object.values(EVENT_TYPE).map(({ eventType, trans }) => ({
            id: eventType,
            label: trans,
            values: {
                email: isChecked(eventType, MEDIA_OPTIONS.EMAIL),
                mobile: isChecked(eventType, MEDIA_OPTIONS.SMS_MESSAGE),
                app: isChecked(eventType, MEDIA_OPTIONS.APP_NOTIFICATION),
            },
        }));
    }, [item]);
    
    // Handle checkbox changes by mapping column key to media option
    const handleMatrixChange = (e, rowId, columnKey) => {
        const mapMediaOption = {
            email: MEDIA_OPTIONS.EMAIL,
            mobile: MEDIA_OPTIONS.SMS_MESSAGE,
            app: MEDIA_OPTIONS.APP_NOTIFICATION,
        };

        handleChange(
            e,
            null,
            rowId,
            mapMediaOption[columnKey]
        );
    };

    return (
        <div className="col-12 m-0 p-0">
            <div className="row">
                <BorderTopTable
                    columns={columns}
                    rows={rows}
                    t={t}
                    disabled={disabled}
                    onChange={handleMatrixChange}
                />
            </div>
        </div>
    );
};

export default NotificationChannelsTable;
